import { callApi } from 'services/api/api'
import { toastStore } from 'stores/toast'
import { TOAST_TYPE } from 'utils/constants'
import { baseURL } from 'services/api/apiConfig'
import { appSelected } from 'stores/navigation'

let selectedApplication = 'physician'
appSelected.subscribe(value => {
  if (value.toLocaleLowerCase() === 'app') {
    selectedApplication = 'app'
  } else {
    selectedApplication = 'physician'
  }
})

export const postManageDataCustomModuleGrid = async ({ body }) => {
  return new Promise((resolve, reject) => {
    callApi(`${baseURL}/manage-data/custom-module/${selectedApplication}/grid`, 'POST', body)
      .then(data => {
        // @ts-ignore
        resolve(data)
      })
      .catch(error => {
        toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting custom module market data')
        reject(error)
      })
  })
}

export const postManageDataCustomModuleHeader = async ({ body }) => {
  return new Promise((resolve, reject) => {
    callApi(`${baseURL}/manage-data/custom-module/${selectedApplication}/header`, 'POST', body)
      .then(data => {
        // @ts-ignore
        resolve(data)
      })
      .catch(error => {
        toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting custom module market data')
        reject(error)
      })
  })
}

/**
 * Gets the list of available user Custom module for Grid.
 */
export const getManageDataCustomModuleGrid = async ({ body }) => {
  return new Promise((resolve, reject) => {
    callApi(`${baseURL}/manage-data/custom-module/${selectedApplication}/grid`, 'POST', body)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        if (error.response?.status === 404) {
          console.warn('Data not found, returning empty array.')
          resolve([])
        } else {
          toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting custom module')
          reject(error)
        }
      })
  })
}

/**
 * Delete custom.
 * @param {number} marketDataHeaderKey - The ID of the blend.
 * @returns {Promise<string>} - A promise that resolves to a confirmation message.
 */
export const deleteCustom = async marketDataHeaderKey => {
  try {
    return callApi(`${baseURL}/surveys/custom-module/${marketDataHeaderKey}`, 'DELETE')
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error deleting survey ')
    return ''
  }
}

/**
 * Saves the Custom module
 * @param {object} customModule - The custom module object containing Survey key and survey cut.
 */
export const postManageDataCustomModule = async customModule => {
  try {
    await callApi(`${baseURL}/surveys/custom-module/${selectedApplication}`, 'POST', customModule)
    return []
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error saving custom module')
    return []
  }
}

export const postManageDataCustomModuleExport = async ({ body }) => {
  try {
    return await callApi(`${baseURL}/manage-data/custom-module/${selectedApplication}/export`, 'POST', body)
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error exporting custom module market data')
    throw error
  }
}
